import { motion, AnimatePresence } from "framer-motion";
import tw from "twin.macro";

const StyledMessage = tw(motion.div)`
  bg-primary-500
  text-white
  px-6
  py-3
  rounded-lg
  shadow-lg
  font-display
  text-sm
  md:text-base
  my-4
  inline-block
  transform
  hover:scale-105
  transition-transform
  duration-300
`;

const MessageAnimation = ({ message, hasSentMessage }) => {
  return (
    <AnimatePresence>
      {hasSentMessage && (
        <StyledMessage
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{
            // type: "spring",
            // damping: 100,
            // stiffness: 1
            type: "tween",
  ease: "easeIn",
  duration: 0.4
          }}
        >
          {message}
        </StyledMessage>
      )}
    </AnimatePresence>
  );
};

export default MessageAnimation;
